import React, { useState, useEffect, useRef } from 'react';
import './index.module.less';

import NavBar from '@components/NavBar';
import { ISchoolClassDisableConfig } from '@apis/types';
import Http from '@helpers/Http';
import { Api } from '@apis/client';
import Filter from '@helpers/Filter';

const ClassDisableSchoolSetting = () => {
  const params = useRef(Filter.urlParams(window.location.search));
  const [schoolDisableConfig, setDisableConfig] = useState<ISchoolClassDisableConfig>();

  const renderEveryDaySame = () => {
    const firstDay = schoolDisableConfig.days[0];
    return (
      <>
       <p>每日禁用时间</p>
       <div className='flex' styleName='list'>
            {firstDay.items.map((item, index) => {
              return (
                <div key={index} className='flex' styleName='item-container'>
                  <p styleName='dark-text'>{`${item.startTime} - ${item.endTime}`}</p>
                </div>
              );
            })}
          </div>
      </>
    );
  }

  const render5Plus2Days = () => {
    const firstDay = schoolDisableConfig.days[0];
    let part1;
    if (parseInt(firstDay.day) < 6) {
      part1 = (
        <>
          <p>工作日禁用时间</p>
          <div className='flex' styleName='list'>
            {firstDay.items.map((item, index) => {
              return (
                <div key={index} className='flex' styleName='item-container'>
                  <p styleName='dark-text'>{`${item.startTime} - ${item.endTime}`}</p>
                </div>
              );
            })}
          </div>
        </>
      )
    }
    let part2;
    const lastDay = schoolDisableConfig.days[schoolDisableConfig.days.length-1];
    if (parseInt(lastDay.day) > 5) {
      part2 = (
        <>
          <p>周末禁用时间</p>
          <div className='flex' styleName='list'>
            {lastDay.items.map((item, index) => {
              return (
                <div key={index} className='flex' styleName='item-container'>
                  <p styleName='dark-text'>{`${item.startTime} - ${item.endTime}`}</p>
                </div>
              );
            })}
          </div>
        </>
      )
    }
    return (
      <>
        {part1}
        {part2}
      </>
    );
  }

  const renderEveryDayDifferent = () => {
    const getDayText = (day: string) => {
      const dayNumber = parseInt(day);
      switch(dayNumber) {
        case 1: return "一";
        case 2: return "二";
        case 3: return "三";
        case 4: return "四";
        case 5: return "五";
        case 6: return "六";
        case 7: return "日";
        default: return "一";
      }
    }
    return (
      <>
        {schoolDisableConfig.days.map((day, index) => {
          return (
            <div key={index}>
              <p>{`周${getDayText(day.day)}禁用时间`}</p>
              <div className='flex' styleName='list'>
                {day.items.map((item, innerIndex) => {
                  return (
                    <div key={innerIndex} className='flex' styleName='item-container'>
                      <p styleName='dark-text'>{`${item.startTime} - ${item.endTime}`}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </>
    );
  }

  const renderSchoolDisableConfig = () => {
    const items = () => {
      switch (schoolDisableConfig && schoolDisableConfig.strategy) {
        case 4: {
          return renderEveryDaySame();
        }
        case 5: {
          return render5Plus2Days();
        }
        case 6: {
          return renderEveryDayDifferent();
        }
      }
    }


    return (
      <div className='flex' styleName='column-container'>
        {items()}
      </div>
    );
  }

  const loadData = async () => {
    const { data } = await Http.post(Api.GetClassDisableSchoolConfig, {
      sncode: params.current.sncode,
      company: params.current.company,
    });
    if (data) {
      console.log(data)
      setDisableConfig(data);
    }
  }

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div styleName="container">
      <NavBar
        title="学校免打扰"
      />
      <div className='flex' styleName='content'>
        {renderSchoolDisableConfig()}
        <p>在禁用时，设备静音且限制电话呼出与接听，仍可进行SOS求救</p>
      </div>
    </div>
  );
}

export default ClassDisableSchoolSetting;
